import type { EntityTypeResource } from '~/api/managed-entities/typedefs.autogen';

import type { EntityType } from '../types/EntityType';

// Flattens the JSON:API resource returned by the managed-entities service into
// the shape the UI works with (id alongside its attributes).
export const toEntityType = (resource: EntityTypeResource): EntityType => ({
  id: resource.id,
  name: resource.attributes.name,
  description: resource.attributes.description,
  is_system: resource.attributes.is_system,
  grouping_uf_field_id: resource.attributes.grouping_uf_field_id,
  grouping_mode: resource.attributes.grouping_mode,
  job_status: resource.attributes.job_status,
});
